import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "../components/ui/button";

export default function WelkomPagina({ status }) {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect({
      scopes: ["User.Read", "openid", "profile", "offline_access"],
    });
  };

  // 🟥 Meldingen per status
  let melding = null;
  if (status === "notCustomer") {
    melding = (
      <p className="text-red-600 font-semibold mb-4">
        ❌ Alleen klanten van NextGen Workspace kunnen dit portaal gebruiken. Neem contact op met NextGen Workspace voor meer informatie.
      </p>
    );
  } else if (status === "notActivated") {
    melding = (
      <p className="text-red-600 font-semibold mb-4">
        ⚠️ Je account is herkend, maar het klantportaal is nog niet geactiveerd.
Neem contact op met NextGen Workspace om toegang te krijgen.
      </p>
    );
     } else if (status === "stagingDenied") {
    melding = (
      <p className="text-red-600 font-semibold mb-4">
        🚫 Deze <strong>testomgeving</strong> is alleen toegankelijk indien noodzakelijk om te testen.  
        Klanten van NextGen Workspace hebben hier standaard geen toegang toe.
      </p>
    );
  } else if (status === "error") {
    melding = (
      <p className="text-red-600 font-semibold mb-4">
        ⚠️ Er ging iets mis bij het controleren van je klantstatus. Probeer het later opnieuw.
      </p>
    );
  } else if (status === "idle") {
    melding = (
      <p className="text-gray-600 mb-4">
        Log in om toegang te krijgen tot het klantportaal.
      </p>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-md text-center">
        {/* NGW logo */}
        <img
          src="/logo-nextgen.jpg"
          alt="NextGen Workspace"
          className="mx-auto mb-6 max-h-20"
        />

        {/* Titel */}
        <h1 className="text-2xl font-bold mb-3">Welkom op het Klantportaal</h1>

        {/* Dynamische melding */}
        {melding}

        {/* Login knop alleen tonen bij idle of error */}
        {(status === "idle" || status === "error") && (
          <Button onClick={handleLogin} className="inline-flex items-center px-6 py-3 rounded-2xl bg-gray-100 text-gray-800 border border-gray-300 hover:bg-gray-200 transition">
            Inloggen
          </Button>
        )}
      </div>
    </div>
  );
}
